@if (displayedTags$ | async; as displayedTags) {
  <div
    [ngClass]="{
      'tag-container-expanded': expanded,
      'tag-container': !expanded && mode === 'single-line',
      'tag-container-multiline': mode === 'multi-line',
    }"
  >
    <div class="tag-display">
      @for (tag of displayedTags; track tag) {
        <span
          [class.removable]="removableTag"
          [nimbusBulkValue]="getBulkValue(tag)"
          [isBulk]="isBulk"
          [identical]="getBulkValue(tag)?.identical"
          [bulkDisabled]="bulkDisabled"
          class="tag"
        >
          {{ tag.name || tag }}
          @if (tag?.postFix) {
            <i [nimbusIcon]="tag?.postFix"></i>
          }
          <span class="tag-item-tooltip flex-container flex-column">
            <nimbus-tooltip [text]="tag.name || tag"></nimbus-tooltip>
          </span>
          @if (removableTag) {
            <i [nimbusIcon]="icons.CLOSE" (click)="removeTag(tag)">
              <span class="tag-item-tooltip flex-container flex-column">
                <nimbus-tooltip
                  [text]="TranslationKeys.GeneralRemoveEntity | translate: { entity: TranslationKeys.GeneralTag | translate }"
                ></nimbus-tooltip>
              </span>
            </i>
          }
        </span>
      }
      @if (showExpand) {
        <span class="tag tag-expander" (click)="expand()">...</span>
      }
    </div>
    <div class="tag-original-hidden-container" #tagDisplay>
      @for (tag of transformedTagNames; track tag) {
        <span class="tag" [class.removable]="removableTag">
          {{ tag.name || tag }}
          @if (tag?.postFix) {
            <i [nimbusIcon]="tag?.postFix"></i>
          }
          @if (removableTag) {
            <i
              [nimbusIcon]="icons.CLOSE"
              (click)="removeTag(tag)"
              [title]="TranslationKeys.GeneralRemoveEntity | translate: { entity: TranslationKeys.GeneralTag | translate }"
            ></i>
          }
        </span>
      }
    </div>
    <ng-content></ng-content>
  </div>
}
